/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';

import ActualStage from './actual-stage';
import * as ResultsUtils from '../utils/results';

export default class FirstOrderActualStage extends ActualStage {
  whoAmI = 'app/models/stages/actual-first-order.js';

  getActualFpArray(loopFp) {
    return [loopFp, loopFp * 0.9999, loopFp * 0.999, loopFp * 0.99, loopFp * 0.9, loopFp];
  }

  getActualQArray() {
    return [1, 1, 1, 1, 1, 1];
  }

  getActualGainArray(gain) {
    return [1, 1, 1, 1, 1, gain * 0.98];
  }

  @computed('filter', 'stageFp', 'gain') get stepResponseSetup() {
    var base = this; // for readability. To know which properties are declared in the base class
    var filter = base.filter;
    var actualStageFp = base.stageFp;
    var gain = base.gain;
    var result = filter.setupFirstOrderStepResponse(actualStageFp, gain);
    return result;
  }

  @computed('timeAxis', 'stepResponseSetup') get stepResponseIdeal() {
    var timeAxis = this.timeAxis;
    var stepResponseSetup = this.stepResponseSetup;
    var result = timeAxis.map((timePoint) => {
      var res = ResultsUtils.computeFirstOrderStepResponseIdeal(timePoint, stepResponseSetup);
      return res;
    });

    return result;
  }
}
